import { render, staticRenderFns } from "./PausedAlertsTable.vue?vue&type=template&id=0b11be1a&"
import script from "./PausedAlertsTable.vue?vue&type=script&lang=js&"
export * from "./PausedAlertsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports